import React from "react";

const SessionContext = React.createContext({
    accountId: null,
    apiKey: null,
    profile: null,
});
export default SessionContext;
